import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  return <section className="relative pt-20 pb-24 lg:pt-32 lg:pb-32 overflow-hidden bg-cream" data-id="element-70">
      <div className="absolute top-0 left-0 w-full h-full bg-sage-50/50 -z-10 rounded-br-[100px] lg:rounded-br-[200px]" data-id="element-71"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-72">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-73">
          <div className="max-w-2xl" data-id="element-74">
            <FadeIn data-id="element-75">
              <span className="inline-block py-1 px-3 rounded-full bg-sage-100 text-sage-700 text-sm font-semibold tracking-wide mb-6" data-id="element-76">
                S.O.S. Berrinches
              </span>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-77">
                El Método{' '}
                <span className="text-sage-600 italic" data-id="element-78">"Circuit Breaker"</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-79">
              <h2 className="text-xl sm:text-2xl text-charcoal-light font-medium mb-8 leading-relaxed" data-id="element-80">
                Detén las crisis de llanto y los gritos en menos de 3 minutos
                —sin perder los nervios ni sentirte juzgada en público.
              </h2>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-81">
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-cream-dark mb-8 relative" data-id="element-82">
                <div className="absolute -left-3 -top-3 text-4xl" data-id="element-83">🛒</div>
                <p className="text-charcoal-light leading-relaxed" data-id="element-84">
                  <strong data-id="element-85">Estás en la mitad del supermercado.</strong> Tu hijo
                  se lanza al suelo, los gritos perforan tus oídos y empiezas a
                  sentir ese calor subiendo por tu cuello. Notas las miradas de
                  juicio de los desconocidos.
                </p>
                <p className="text-charcoal-light leading-relaxed mt-4" data-id="element-86">
                  En ese microsegundo, sientes que vas a explotar. Quieres
                  gritar más fuerte que él solo para que se detenga, pero sabes
                  que eso solo empeora el incendio. La culpa te invade antes de
                  que la crisis termine.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-87">
              <Button href="#oferta" className="w-full sm:w-auto" data-id="element-88">
                ¡SÍ, QUIERO RECUPERAR LA PAZ AHORA!
              </Button>
            </FadeIn>
          </div>

          <div className="relative lg:ml-auto" data-id="element-89">
            <FadeIn direction="left" delay={0.2} data-id="element-90">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-91">
                <div className="absolute inset-0 bg-sage-500/10 mix-blend-multiply" data-id="element-92"></div>
                <img src="https://cdn.magicpatterns.com/uploads/nHxY1EGKVazB4RW6RDfD3E/heylloyd-image_del_libro_-SOS.png" alt="Padres usando el método S.O.S. Berrinches" className="w-full h-auto object-cover" data-id="element-93" />
              </div>

              {/* Decorative elements */}
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-terracotta-light rounded-full -z-10" data-id="element-94"></div>
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-sage-100 rounded-full -z-10" data-id="element-95"></div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}